import React, { useState, useCallback } from "react";
import { FullscreenOutlined, FullscreenExitOutlined } from "@ant-design/icons";
import styles from "./index.module.less";

function MaximizedPanelContainer({ name, children }) {
  const [maxium, setMaxium] = useState(false);
  const toggleSize = useCallback(() => {
    setMaxium(!maxium);
  }, [setMaxium, maxium]);
  return (
    <div className={styles.maximizedPanelContainer}>
      <div className={maxium ? "panel maxium" : "panel"}>
        <div className="title">
          {name}
          <span className="toolbar">
            {maxium ? (
              <FullscreenExitOutlined onClick={toggleSize} />
            ) : (
              <FullscreenOutlined onClick={toggleSize} />
            )}
          </span>
        </div>
        <div className="body">{children}</div>
      </div>
    </div>
  );
}

export default MaximizedPanelContainer;
